/* Updated TasksPage: Ensuring visibility and adding Copy functionality */
import React, { useState } from 'react';
import { Step1Tasks } from '../ProjectBuilder/Step1Tasks';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

export const TasksPage = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      className="h-full flex flex-col bg-base-900"
    >
      <div className="p-6 border-b border-base-700 bg-base-800 shrink-0">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <SafeIcon name="CheckSquare" className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h1 className="text-2xl font-bold">Task Templates</h1>
            <p className="text-sm text-gray-400">Manage your reusable task library and app integrations.</p>
          </div>
        </div>
      </div>
      
      <div className="flex-1 p-6 overflow-hidden">
        <Step1Tasks />
      </div>
    </motion.div>
  );
};